import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { buildUniqueClassName } from '~/helpers/seo-helpers';
import ArrowLink from '~/components/molecules/ArrowLink.vue';
import CategoryCheckboxFilter from '~/components/organisms/Category/CategoryCheckboxFilter.vue';
import CategoryDimensionsFilter from '~/components/organisms/Category/CategoryDimensionsFilter.vue';
import CategoryTags from '~/components/organisms/Category/CategoryTags.vue';
import TransitionExpand from '~/components/templates/TransitionExpand.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cross.svg';

var CategoryRangeFilter = function CategoryRangeFilter() {
  return import('~/components/organisms/Category/CategoryRangeFilter.vue');
};

var BASIC_FILTERS_LENGTH = 7;
export default {
  name: 'CategoryFiltersBar',
  components: {
    ArrowLink: ArrowLink,
    CategoryCheckboxFilter: CategoryCheckboxFilter,
    CategoryDimensionsFilter: CategoryDimensionsFilter,
    CategoryRangeFilter: CategoryRangeFilter,
    CategoryTags: CategoryTags,
    TransitionExpand: TransitionExpand
  },
  props: {
    activeFilters: {
      type: Array,
      required: true
    },
    filters: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      selectedFilter: null,
      buildUniqueClassName: buildUniqueClassName
    };
  },
  computed: _objectSpread({}, mapGetters({
    productsCount: 'category/productsCount'
  }), {
    validFilters: function validFilters() {
      return this.filters && this.filters.length > 0 ? this.filters.filter(function (f) {
        return f.facets;
      }) : [];
    },
    basicFiltersLength: function basicFiltersLength() {
      return this.validFilters && this.validFilters.length > BASIC_FILTERS_LENGTH + 1 ? BASIC_FILTERS_LENGTH : BASIC_FILTERS_LENGTH + 1;
    },
    basicFilters: function basicFilters() {
      return this.filters.slice(0, this.basicFiltersLength);
    },
    seeResultsLabel: function seeResultsLabel() {
      return this.productsCount ? "".concat(this.$t('btn-see-results'), " (").concat(this.productsCount, ")") : this.$t('btn-see-results');
    },
    activeTags: function activeTags() {
      return this.activeFilters.filter(function (e) {
        return e.label;
      });
    }
  }),
  watch: {
    activeFilters: function activeFilters() {
      var _this = this;

      this.selectedFilter = this.selectedFilter ? this.filters.find(function (f) {
        return f.name === _this.selectedFilter.name;
      }) : null;
    }
  },
  methods: {
    selectFilter: function selectFilter(filter) {
      this.selectedFilter = this.selectedFilter !== filter ? filter : null;
    },
    openLayer: function openLayer() {
      this.$root.$emit('open-layer', {
        state: true,
        name: 'FiltersLayer',
        filters: this.validFilters
      });
      window.document.querySelector('body').style.overflow = 'hidden';
      return false;
    }
  }
};